import { v4 } from 'uuid';

import { Origin } from '@videoblocks/events-ts/lib/storyblocks/navigation/OriginEnum';
import { SignupSurveyEntEvent } from '@videoblocks/events-ts/lib/storyblocks/user/SignupSurveyEntEvent';

import { CommonRecordFactory } from '../shared/CommonRecordFactory';

export type SignupSurveyEventFactoryOptions = {
    visitorCookieId: string | null;
    channel: string;
    comment: string;
    sessionToken: string | undefined;
};

async function create(options: SignupSurveyEventFactoryOptions): Promise<SignupSurveyEntEvent> {
    const { visitorCookieId, channel, comment, sessionToken } = options;

    const event = new SignupSurveyEntEvent();
    event.meta = {
        uuid: v4(),
        emitted: Date.now(),
        origin: Origin.STORYBLOCKS_NEXTJS,
        trace: null,
    };
    event.user = await CommonRecordFactory.user(sessionToken, visitorCookieId);
    event.channel = channel;
    event.comment = comment;

    return event;
}

export const SignupSurveyEventFactory = { create };
